<script>
import Subscription from "./Subscription/Index";
import NoSubscriptions from "./NoSubscriptions";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Subscription,
    NoSubscriptions
  },
  computed: {
    ...mapState("subscriptions", [
      "list",
      "loader",
      "pagination",
      "sort",
      "type"
    ])
  },
  methods: {
    ...mapActions("subscriptions", ["listAll", "setCurrentPage", "setSort"])
  },
  mounted() {
    this.listAll();
  }
};
</script>

<template>
  <div class="container">
    <no-subscriptions v-if="!list.length && !loader" />
    <subscription
      v-else
      v-for="subscription in list"
      :key="subscription.id"
      :subscription="subscription"
    />
  </div>
</template>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions/Index.vue